import { useOptOutApi } from "../api/OptOutApiClient";
import { OptOutFrontendService } from "../services/OptOutFrontendService";

export const useOptOutService = (): OptOutFrontendService =>
  new OptOutFrontendService(useOptOutApi());
